import { useWallet } from '../../../wallet/hooks/use-wallet';
import { useSellerLabelProviders } from '../../../hooks/use-seller-label-providers';
import { useNormalizedBYOLProviders } from '../../../hooks/use-normalized-BYOL-providers';
import { Providers } from '../../../enums/providers';
import { useMemo } from 'react';

export const useShippingServiceData = () => {
  const { walletId, isWalletRegistered } = useWallet();
  const sellerLabelProviders = useSellerLabelProviders();
  const BYOLProviders = useNormalizedBYOLProviders();

  return useMemo(() => {
    const filteredSellerLabelProviders = sellerLabelProviders.filter((provider) => {
      const isInUnregisteredWallet = !!provider.walletId && provider.walletId === walletId && !isWalletRegistered;
      const unregisteredAutoProvisionedProvider = provider.useHouseCredentials;
      const isBYOLProvider = !!BYOLProviders[provider.labelProviderId];
      const isCarrierSharingProvider = provider.labelProviderId === Providers.ClientSharedCarriers.labelProviderId;
      return !(isInUnregisteredWallet || unregisteredAutoProvisionedProvider || isBYOLProvider || isCarrierSharingProvider);
    });

    return {
      isShippingServiceComplete: filteredSellerLabelProviders.length > 0,
      filteredSellerLabelProviders,
    };
  }, [BYOLProviders, isWalletRegistered, sellerLabelProviders, walletId]);
};
